var _radialGradient, _radialGradient2, _radialGradient3, _radialGradient4, _radialGradient5, _radialGradient6, _radialGradient7, _radialGradient8, _radialGradient9, _radialGradient10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWinterBreak(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 662.457,
    height: 428.954,
    viewBox: "0 0 175.275 113.494",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#a",
    id: "k",
    cx: 92.399,
    cy: 75.701,
    r: 57.452,
    fx: 92.399,
    fy: 75.701,
    gradientTransform: "matrix(.5575 .00213 -.00237 .58202 -153.3 74.18)",
    gradientUnits: "userSpaceOnUse"
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#a",
    id: "i",
    cx: 92.399,
    cy: 75.701,
    r: 57.452,
    fx: 92.399,
    fy: 75.701,
    gradientTransform: "matrix(.5575 .00213 -.00237 .58202 -153.3 74.18)",
    gradientUnits: "userSpaceOnUse"
  })), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#a",
    id: "j",
    cx: 92.399,
    cy: 75.701,
    r: 57.452,
    fx: 92.399,
    fy: 75.701,
    gradientTransform: "matrix(.5575 .00213 -.00237 .58202 -153.3 74.18)",
    gradientUnits: "userSpaceOnUse"
  })), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#a",
    id: "g",
    cx: 92.399,
    cy: 75.701,
    r: 57.452,
    fx: 92.399,
    fy: 75.701,
    gradientTransform: "matrix(.5575 .00213 -.00237 .58202 -153.3 74.18)",
    gradientUnits: "userSpaceOnUse"
  })), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#a",
    id: "h",
    cx: 92.399,
    cy: 75.701,
    r: 57.452,
    fx: 92.399,
    fy: 75.701,
    gradientTransform: "matrix(.5575 .00213 -.00237 .58202 -153.3 74.18)",
    gradientUnits: "userSpaceOnUse"
  })), _radialGradient6 || (_radialGradient6 = /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#a",
    id: "f",
    cx: 92.399,
    cy: 75.701,
    r: 57.452,
    fx: 92.399,
    fy: 75.701,
    gradientTransform: "matrix(.5575 .00213 -.00237 .58202 -153.3 74.18)",
    gradientUnits: "userSpaceOnUse"
  })), _radialGradient7 || (_radialGradient7 = /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#a",
    id: "e",
    cx: 92.399,
    cy: 75.701,
    r: 57.452,
    fx: 92.399,
    fy: 75.701,
    gradientTransform: "matrix(.5575 .00213 -.00237 .58202 -153.3 74.18)",
    gradientUnits: "userSpaceOnUse"
  })), _radialGradient8 || (_radialGradient8 = /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#a",
    id: "d",
    cx: 92.399,
    cy: 75.701,
    r: 57.452,
    fx: 92.399,
    fy: 75.701,
    gradientTransform: "matrix(.5575 .00213 -.00237 .58202 -153.3 74.18)",
    gradientUnits: "userSpaceOnUse"
  })), _radialGradient9 || (_radialGradient9 = /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#a",
    id: "c",
    cx: 92.399,
    cy: 75.701,
    r: 57.452,
    fx: 92.399,
    fy: 75.701,
    gradientTransform: "matrix(.5575 .00213 -.00237 .58202 -153.3 74.18)",
    gradientUnits: "userSpaceOnUse"
  })), _radialGradient10 || (_radialGradient10 = /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#a",
    id: "b",
    cx: 92.399,
    cy: 75.701,
    r: 57.452,
    fx: 92.399,
    fy: 75.701,
    gradientTransform: "matrix(.5575 .00213 -.00237 .58202 -153.3 74.18)",
    gradientUnits: "userSpaceOnUse"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ffd42a",
      stopOpacity: 0.28638497
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffd42a",
      stopOpacity: 0
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-7.527 -283.71)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.527 283.71v113.495h175.276V283.71z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.87204337,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.527 283.71v113.495h175.276V283.71z",
    style: {
      fill: "#dcfbff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.87204337,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.117,
    cy: -95.439,
    r: 0.466,
    style: {
      opacity: 1,
      fill: "#fff3ad",
      fillOpacity: 0.73708921,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.07677704,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.83568073,
      paintOrder: "normal"
    },
    transform: "scale(1 -1)rotate(-60.783)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 376.8,
    cy: -91.838,
    r: 0.167,
    style: {
      opacity: 1,
      fill: "#fff3ad",
      fillOpacity: 0.73708921,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.02742037,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.83568073,
      paintOrder: "normal"
    },
    transform: "scale(1 -1)rotate(-60.783)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 380.12,
    cy: -86.823,
    r: 0.4,
    style: {
      opacity: 1,
      fill: "#fff3ad",
      fillOpacity: 0.73708921,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.06580889,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.83568073,
      paintOrder: "normal"
    },
    transform: "scale(1 -1)rotate(-60.783)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-137.569 84.719h70.899v68.896h-70.899z",
    style: {
      fill: "url(#b)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.89571607,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(.41294 .0228 .0228 -.41294 153.985 423.748)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.95 124.304c-1.5.402-7.087-9.172-8.537-9.729s-12.009 2.82-12.855 1.518c-.846-1.303 6.533-9.575 6.615-11.126s-6.393-10.55-5.416-11.757c.978-1.207 11.125 3.255 12.626 2.853s8.057-9.34 9.507-8.783c1.45.556.343 11.586 1.189 12.889s11.372 4.777 11.291 6.328-10.913 3.906-11.89 5.113-1.03 12.292-2.53 12.694",
    style: {
      fill: "#ffd42a",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.34134436,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(.32542 .25523 .25523 -.32542 35.938 366.111)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-137.569 84.719h70.899v68.896h-70.899z",
    style: {
      fill: "url(#c)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.89571607,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(.12267 .00677 .00677 -.12267 97.76 393.89)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.95 124.304c-1.5.402-7.087-9.172-8.537-9.729s-12.009 2.82-12.855 1.518c-.846-1.303 6.533-9.575 6.615-11.126s-6.393-10.55-5.416-11.757c.978-1.207 11.125 3.255 12.626 2.853s8.057-9.34 9.507-8.783c1.45.556.343 11.586 1.189 12.889s11.372 4.777 11.291 6.328-10.913 3.906-11.89 5.113-1.03 12.292-2.53 12.694",
    style: {
      fill: "#ffd42a",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.34134436,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(.09667 .07582 .07582 -.09667 62.693 376.77)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    },
    transform: "rotate(-9.221 2213.177 -492.824)scale(.3683)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32.96,
    cy: 52.909,
    r: 2.581,
    style: {
      opacity: 1,
      fill: "#fff3ad",
      fillOpacity: 0.73708921,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.19935203,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.83568073,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.868,
    cy: 62.729,
    r: 0.892,
    style: {
      opacity: 1,
      fill: "#fff3ad",
      fillOpacity: 0.73708921,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.14689097,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.83568073,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.609,
    cy: 69.619,
    r: 0.319,
    style: {
      opacity: 1,
      fill: "#fff3ad",
      fillOpacity: 0.73708921,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.05246105,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.83568073,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.2,
    cy: 56.519,
    r: 1.466,
    style: {
      opacity: 1,
      fill: "#fff3ad",
      fillOpacity: 0.73708921,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.24132088,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.83568073,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.961,
    cy: 79.214,
    r: 0.765,
    style: {
      opacity: 1,
      fill: "#fff3ad",
      fillOpacity: 0.73708921,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.12590654,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.83568073,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    },
    transform: "matrix(.51016 .11371 .11371 -.51016 92.35 345.395)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32.96,
    cy: 52.909,
    r: 2.581,
    style: {
      opacity: 1,
      fill: "#fff3ad",
      fillOpacity: 0.73708921,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.19935203,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.83568073,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.868,
    cy: 62.729,
    r: 0.892,
    style: {
      opacity: 1,
      fill: "#fff3ad",
      fillOpacity: 0.73708921,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.14689097,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.83568073,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.609,
    cy: 69.619,
    r: 0.319,
    style: {
      opacity: 1,
      fill: "#fff3ad",
      fillOpacity: 0.73708921,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.05246105,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.83568073,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.2,
    cy: 56.519,
    r: 1.466,
    style: {
      opacity: 1,
      fill: "#fff3ad",
      fillOpacity: 0.73708921,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.24132088,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.83568073,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.961,
    cy: 79.214,
    r: 0.765,
    style: {
      opacity: 1,
      fill: "#fff3ad",
      fillOpacity: 0.73708921,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.12590654,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.83568073,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: -175.222,
    cy: 268.973,
    r: 0.329,
    style: {
      opacity: 1,
      fill: "#fff3ad",
      fillOpacity: 0.73708921,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0541003,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.83568073,
      paintOrder: "normal"
    },
    transform: "rotate(-57.442)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -178.263,
    cy: 271.511,
    r: 0.117,
    style: {
      opacity: 1,
      fill: "#fff3ad",
      fillOpacity: 0.73708921,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.01932153,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.83568073,
      paintOrder: "normal"
    },
    transform: "rotate(-57.442)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -175.924,
    cy: 275.045,
    r: 0.282,
    style: {
      opacity: 1,
      fill: "#fff3ad",
      fillOpacity: 0.73708921,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.04637169,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.83568073,
      paintOrder: "normal"
    },
    transform: "rotate(-57.442)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-137.569 84.719h70.899v68.896h-70.899z",
    style: {
      fill: "url(#d)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.89571607,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "scale(.12285)rotate(89.554 -965.402 2370.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.95 124.304c-1.5.402-7.087-9.172-8.537-9.729s-12.009 2.82-12.855 1.518c-.846-1.303 6.533-9.575 6.615-11.126s-6.393-10.55-5.416-11.757c.978-1.207 11.125 3.255 12.626 2.853s8.057-9.34 9.507-8.783c1.45.556.343 11.586 1.189 12.889s11.372 4.777 11.291 6.328-10.913 3.906-11.89 5.113-1.03 12.292-2.53 12.694",
    style: {
      fill: "#ffd42a",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.34134436,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(.07115 .10015 -.10015 .07115 158.148 371.775)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    },
    transform: "rotate(75.574 -175.56 227.186)scale(.52268)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32.96,
    cy: 52.909,
    r: 2.581,
    style: {
      opacity: 1,
      fill: "#fff3ad",
      fillOpacity: 0.73708921,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.19935203,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.83568073,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.868,
    cy: 62.729,
    r: 0.892,
    style: {
      opacity: 1,
      fill: "#fff3ad",
      fillOpacity: 0.73708921,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.14689097,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.83568073,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.609,
    cy: 69.619,
    r: 0.319,
    style: {
      opacity: 1,
      fill: "#fff3ad",
      fillOpacity: 0.73708921,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.05246105,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.83568073,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.2,
    cy: 56.519,
    r: 1.466,
    style: {
      opacity: 1,
      fill: "#fff3ad",
      fillOpacity: 0.73708921,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.24132088,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.83568073,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.961,
    cy: 79.214,
    r: 0.765,
    style: {
      opacity: 1,
      fill: "#fff3ad",
      fillOpacity: 0.73708921,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.12590654,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.83568073,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-137.569 84.719h70.899v68.896h-70.899z",
    style: {
      fill: "url(#e)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.89571607,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(-.28309 .3015 -.3015 -.28309 36.306 419.256)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.95 124.304c-1.5.402-7.087-9.172-8.537-9.729s-12.009 2.82-12.855 1.518c-.846-1.303 6.533-9.575 6.615-11.126s-6.393-10.55-5.416-11.757c.978-1.207 11.125 3.255 12.626 2.853s8.057-9.34 9.507-8.783c1.45.556.343 11.586 1.189 12.889s11.372 4.777 11.291 6.328-10.913 3.906-11.89 5.113-1.03 12.292-2.53 12.694",
    style: {
      fill: "#ffd42a",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.34134436,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "scale(-.41357)rotate(-81.75 -512.678 -243.47)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-137.569 84.719h70.899v68.896h-70.899z",
    style: {
      fill: "url(#f)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.89571607,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(-.0841 .08956 -.08956 -.0841 60.778 392.26)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.95 124.304c-1.5.402-7.087-9.172-8.537-9.729s-12.009 2.82-12.855 1.518c-.846-1.303 6.533-9.575 6.615-11.126s-6.393-10.55-5.416-11.757c.978-1.207 11.125 3.255 12.626 2.853s8.057-9.34 9.507-8.783c1.45.556.343 11.586 1.189 12.889s11.372 4.777 11.291 6.328-10.913 3.906-11.89 5.113-1.03 12.292-2.53 12.694",
    style: {
      fill: "#ffd42a",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.34134436,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(-.01763 .12158 -.12158 -.01763 74.338 355.669)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    },
    transform: "scale(-.3683 .3683)rotate(34.419 -1600.906 314.526)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32.96,
    cy: 52.909,
    r: 2.581,
    style: {
      opacity: 1,
      fill: "#fff3ad",
      fillOpacity: 0.73708921,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.19935203,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.83568073,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.868,
    cy: 62.729,
    r: 0.892,
    style: {
      opacity: 1,
      fill: "#fff3ad",
      fillOpacity: 0.73708921,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.14689097,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.83568073,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.609,
    cy: 69.619,
    r: 0.319,
    style: {
      opacity: 1,
      fill: "#fff3ad",
      fillOpacity: 0.73708921,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.05246105,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.83568073,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.2,
    cy: 56.519,
    r: 1.466,
    style: {
      opacity: 1,
      fill: "#fff3ad",
      fillOpacity: 0.73708921,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.24132088,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.83568073,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.961,
    cy: 79.214,
    r: 0.765,
    style: {
      opacity: 1,
      fill: "#fff3ad",
      fillOpacity: 0.73708921,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.12590654,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.83568073,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 274.524,
    cy: -200.756,
    r: 1.349,
    style: {
      opacity: 1,
      fill: "#fff3ad",
      fillOpacity: 0.73708921,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.10419742,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.83568073,
      paintOrder: "normal"
    },
    transform: "rotate(123.792)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 285.103,
    cy: -198.87,
    r: 0.766,
    style: {
      opacity: 1,
      fill: "#fff3ad",
      fillOpacity: 0.73708921,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.12613371,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.83568073,
      paintOrder: "normal"
    },
    transform: "rotate(123.792)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    },
    transform: "scale(-.52268 .52268)rotate(-60.783 332.94 648.584)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32.96,
    cy: 52.909,
    r: 2.581,
    style: {
      opacity: 1,
      fill: "#fff3ad",
      fillOpacity: 0.73708921,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.19935203,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.83568073,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.868,
    cy: 62.729,
    r: 0.892,
    style: {
      opacity: 1,
      fill: "#fff3ad",
      fillOpacity: 0.73708921,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.14689097,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.83568073,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.609,
    cy: 69.619,
    r: 0.319,
    style: {
      opacity: 1,
      fill: "#fff3ad",
      fillOpacity: 0.73708921,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.05246105,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.83568073,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.2,
    cy: 56.519,
    r: 1.466,
    style: {
      opacity: 1,
      fill: "#fff3ad",
      fillOpacity: 0.73708921,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.24132088,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.83568073,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.961,
    cy: 79.214,
    r: 0.765,
    style: {
      opacity: 1,
      fill: "#fff3ad",
      fillOpacity: 0.73708921,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.12590654,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.83568073,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-137.569 84.719h70.899v68.896h-70.899z",
    style: {
      fill: "url(#g)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.89571607,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(-.41294 -.0228 -.0228 .41294 113.379 299.025)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.95 124.304c-1.5.402-7.087-9.172-8.537-9.729s-12.009 2.82-12.855 1.518c-.846-1.303 6.533-9.575 6.615-11.126s-6.393-10.55-5.416-11.757c.978-1.207 11.125 3.255 12.626 2.853s8.057-9.34 9.507-8.783c1.45.556.343 11.586 1.189 12.889s11.372 4.777 11.291 6.328-10.913 3.906-11.89 5.113-1.03 12.292-2.53 12.694",
    style: {
      fill: "#ffd42a",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.34134436,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "scale(-.41357 .41357)rotate(-38.108 968.694 1241.303)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-137.569 84.719h70.899v68.896h-70.899z",
    style: {
      fill: "url(#h)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.89571607,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "scale(-.12285 .12285)rotate(-3.161 42935.045 23273)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.95 124.304c-1.5.402-7.087-9.172-8.537-9.729s-12.009 2.82-12.855 1.518c-.846-1.303 6.533-9.575 6.615-11.126s-6.393-10.55-5.416-11.757c.978-1.207 11.125 3.255 12.626 2.853s8.057-9.34 9.507-8.783c1.45.556.343 11.586 1.189 12.889s11.372 4.777 11.291 6.328-10.913 3.906-11.89 5.113-1.03 12.292-2.53 12.694",
    style: {
      fill: "#ffd42a",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.34134436,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "scale(-.12285 .12285)rotate(-38.108 2928.551 3447.473)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    },
    transform: "rotate(170.779 66.525 181.942)scale(.3683)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32.96,
    cy: 52.909,
    r: 2.581,
    style: {
      opacity: 1,
      fill: "#fff3ad",
      fillOpacity: 0.73708921,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.19935203,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.83568073,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.868,
    cy: 62.729,
    r: 0.892,
    style: {
      opacity: 1,
      fill: "#fff3ad",
      fillOpacity: 0.73708921,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.14689097,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.83568073,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.609,
    cy: 69.619,
    r: 0.319,
    style: {
      opacity: 1,
      fill: "#fff3ad",
      fillOpacity: 0.73708921,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.05246105,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.83568073,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.2,
    cy: 56.519,
    r: 1.466,
    style: {
      opacity: 1,
      fill: "#fff3ad",
      fillOpacity: 0.73708921,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.24132088,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.83568073,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.961,
    cy: 79.214,
    r: 0.765,
    style: {
      opacity: 1,
      fill: "#fff3ad",
      fillOpacity: 0.73708921,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.12590654,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.83568073,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    },
    transform: "scale(-.52268 .52268)rotate(-12.565 2905.743 1872.995)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32.96,
    cy: 52.909,
    r: 2.581,
    style: {
      opacity: 1,
      fill: "#fff3ad",
      fillOpacity: 0.73708921,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.19935203,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.83568073,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.868,
    cy: 62.729,
    r: 0.892,
    style: {
      opacity: 1,
      fill: "#fff3ad",
      fillOpacity: 0.73708921,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.14689097,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.83568073,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.609,
    cy: 69.619,
    r: 0.319,
    style: {
      opacity: 1,
      fill: "#fff3ad",
      fillOpacity: 0.73708921,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.05246105,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.83568073,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.2,
    cy: 56.519,
    r: 1.466,
    style: {
      opacity: 1,
      fill: "#fff3ad",
      fillOpacity: 0.73708921,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.24132088,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.83568073,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.961,
    cy: 79.214,
    r: 0.765,
    style: {
      opacity: 1,
      fill: "#fff3ad",
      fillOpacity: 0.73708921,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.12590654,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.83568073,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    },
    transform: "rotate(75.574 -129.067 221.081)scale(.52268)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32.96,
    cy: 52.909,
    r: 2.581,
    style: {
      opacity: 1,
      fill: "#fff3ad",
      fillOpacity: 0.73708921,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.19935203,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.83568073,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.868,
    cy: 62.729,
    r: 0.892,
    style: {
      opacity: 1,
      fill: "#fff3ad",
      fillOpacity: 0.73708921,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.14689097,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.83568073,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.609,
    cy: 69.619,
    r: 0.319,
    style: {
      opacity: 1,
      fill: "#fff3ad",
      fillOpacity: 0.73708921,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.05246105,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.83568073,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.2,
    cy: 56.519,
    r: 1.466,
    style: {
      opacity: 1,
      fill: "#fff3ad",
      fillOpacity: 0.73708921,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.24132088,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.83568073,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.961,
    cy: 79.214,
    r: 0.765,
    style: {
      opacity: 1,
      fill: "#fff3ad",
      fillOpacity: 0.73708921,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.12590654,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.83568073,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-137.569 84.719h70.899v68.896h-70.899z",
    style: {
      fill: "url(#i)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.89571607,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(-.28309 .3015 -.3015 -.28309 65.305 369.645)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.95 124.304c-1.5.402-7.087-9.172-8.537-9.729s-12.009 2.82-12.855 1.518c-.846-1.303 6.533-9.575 6.615-11.126s-6.393-10.55-5.416-11.757c.978-1.207 11.125 3.255 12.626 2.853s8.057-9.34 9.507-8.783c1.45.556.343 11.586 1.189 12.889s11.372 4.777 11.291 6.328-10.913 3.906-11.89 5.113-1.03 12.292-2.53 12.694",
    style: {
      fill: "#ffd42a",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.34134436,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "scale(-.41357)rotate(-81.75 -478.434 -142.981)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-137.569 84.719h70.899v68.896h-70.899z",
    style: {
      fill: "url(#j)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.89571607,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(-.0841 .08956 -.08956 -.0841 89.777 313.838)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.95 124.304c-1.5.402-7.087-9.172-8.537-9.729s-12.009 2.82-12.855 1.518c-.846-1.303 6.533-9.575 6.615-11.126s-6.393-10.55-5.416-11.757c.978-1.207 11.125 3.255 12.626 2.853s8.057-9.34 9.507-8.783c1.45.556.343 11.586 1.189 12.889s11.372 4.777 11.291 6.328-10.913 3.906-11.89 5.113-1.03 12.292-2.53 12.694",
    style: {
      fill: "#ffd42a",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.34134436,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(-.01763 .12158 -.12158 -.01763 103.337 277.246)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    },
    transform: "scale(-.3683 .3683)rotate(34.419 -1422.823 120.07)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32.96,
    cy: 52.909,
    r: 2.581,
    style: {
      opacity: 1,
      fill: "#fff3ad",
      fillOpacity: 0.73708921,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.19935203,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.83568073,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.868,
    cy: 62.729,
    r: 0.892,
    style: {
      opacity: 1,
      fill: "#fff3ad",
      fillOpacity: 0.73708921,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.14689097,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.83568073,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.609,
    cy: 69.619,
    r: 0.319,
    style: {
      opacity: 1,
      fill: "#fff3ad",
      fillOpacity: 0.73708921,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.05246105,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.83568073,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.2,
    cy: 56.519,
    r: 1.466,
    style: {
      opacity: 1,
      fill: "#fff3ad",
      fillOpacity: 0.73708921,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.24132088,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.83568073,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.961,
    cy: 79.214,
    r: 0.765,
    style: {
      opacity: 1,
      fill: "#fff3ad",
      fillOpacity: 0.73708921,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.12590654,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.83568073,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    },
    transform: "rotate(123.792 -39.912 165.846)scale(.52268)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32.96,
    cy: 52.909,
    r: 2.581,
    style: {
      opacity: 1,
      fill: "#fff3ad",
      fillOpacity: 0.73708921,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.19935203,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.83568073,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.868,
    cy: 62.729,
    r: 0.892,
    style: {
      opacity: 1,
      fill: "#fff3ad",
      fillOpacity: 0.73708921,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.14689097,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.83568073,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.609,
    cy: 69.619,
    r: 0.319,
    style: {
      opacity: 1,
      fill: "#fff3ad",
      fillOpacity: 0.73708921,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.05246105,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.83568073,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.2,
    cy: 56.519,
    r: 1.466,
    style: {
      opacity: 1,
      fill: "#fff3ad",
      fillOpacity: 0.73708921,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.24132088,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.83568073,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.961,
    cy: 79.214,
    r: 0.765,
    style: {
      opacity: 1,
      fill: "#fff3ad",
      fillOpacity: 0.73708921,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.12590654,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.83568073,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    },
    transform: "scale(-.3683 .3683)rotate(-13.8 2898.122 720.098)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32.96,
    cy: 52.909,
    r: 2.581,
    style: {
      opacity: 1,
      fill: "#fff3ad",
      fillOpacity: 0.73708921,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.19935203,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.83568073,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.868,
    cy: 62.729,
    r: 0.892,
    style: {
      opacity: 1,
      fill: "#fff3ad",
      fillOpacity: 0.73708921,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.14689097,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.83568073,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.609,
    cy: 69.619,
    r: 0.319,
    style: {
      opacity: 1,
      fill: "#fff3ad",
      fillOpacity: 0.73708921,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.05246105,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.83568073,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.2,
    cy: 56.519,
    r: 1.466,
    style: {
      opacity: 1,
      fill: "#fff3ad",
      fillOpacity: 0.73708921,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.24132088,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.83568073,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.961,
    cy: 79.214,
    r: 0.765,
    style: {
      opacity: 1,
      fill: "#fff3ad",
      fillOpacity: 0.73708921,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.12590654,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.83568073,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-137.569 84.719h70.899v68.896h-70.899z",
    style: {
      fill: "url(#k)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.89571607,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(-.0841 .08956 -.08956 -.0841 20.867 410.45)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.95 124.304c-1.5.402-7.087-9.172-8.537-9.729s-12.009 2.82-12.855 1.518c-.846-1.303 6.533-9.575 6.615-11.126s-6.393-10.55-5.416-11.757c.978-1.207 11.125 3.255 12.626 2.853s8.057-9.34 9.507-8.783c1.45.556.343 11.586 1.189 12.889s11.372 4.777 11.291 6.328-10.913 3.906-11.89 5.113-1.03 12.292-2.53 12.694",
    style: {
      fill: "#ffd42a",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.34134436,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(-.01763 .12158 -.12158 -.01763 34.427 373.859)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1068.354 597.527)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1065.729,
    cy: 383.092,
    r: 8.11,
    style: {
      opacity: 1,
      fill: "#da1300",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.78431392,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    transform: "rotate(-33.597)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1343.82-226.168c.01 0 .03 0 .52-.184.49-.183 1.441-.549 2.158-.502s1.196.507 1.775.501c.58-.006 1.258-.478 1.871-.456.614.021 1.163.536 1.772.522.608-.014 1.274-.555 2.057-.623s1.68.337 2.19.54c.51.202.67.202.316-.024-.356-.225-1.668-.973-2.316-1.69-.65-.717-.56-1.215-.835-1.719-.276-.503-1.144-1.282-1.949-1.618-.804-.336-1.664-.336-2.47-.083-.804.254-1.554.761-1.956 1.395s-.456 1.394-.923 2.073c-.466.68-1.344 1.275-1.781 1.571-.438.297-.438.297-.428.297",
    style: {
      fill: "#ffe600",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: ".26458332px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    transform: "rotate(-34.258 771.965 -575.23)scale(.64532)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1097.45-273.836c-.701 1.135-1.729 1.77-2.296 1.42-.305-.187-.415-.62-.344-1.156.062-.464.483-.906.808-1.433.301-.487.552-.871.797-1.246.324-.497.951-.474 1.275-.274.567.35.46 1.554-.24 2.689zM1094.647-269.256c-.445-.124-.53-1-.246-1.365.317-.41 1.32-.58 1.55-.116.294.59-.67 1.658-1.304 1.481",
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 0.36150237,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.5582031,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1091.873-268.456a8.1 8.1 0 0 0 1.054 2.32 8.1 8.1 0 0 0 2.372 2.323c.764-.564 1.485-1.157 1.472-1.274-.011-.112-.774-.5-1.598-.87.177-.156.291-.275.287-.317-.012-.1-.753-.472-1.5-.798.18-.153.298-.27.293-.31-.016-.147-1.997-1.027-2.38-1.074M1096.07-271.58c-.128.095.146 2.586.293 2.65.034.016.183-.062.383-.187.088.81.22 1.63.312 1.67.04.016.187-.056.389-.179.105.897.249 1.74.351 1.785.22.097 3.258-2.133 3.231-2.372-.01-.112-.773-.5-1.598-.87.178-.156.292-.275.287-.317-.012-.1-.752-.472-1.499-.798.179-.153.297-.271.293-.31-.018-.159-2.312-1.167-2.441-1.072zM1100.35-274.722c-.128.095.146 2.585.292 2.65.035.015.184-.062.383-.187.088.81.22 1.629.313 1.67.04.016.186-.057.389-.18.105.898.248 1.74.35 1.786.221.096 3.258-2.134 3.232-2.373-.011-.112-.773-.5-1.598-.87.178-.156.292-.275.287-.317-.012-.1-.753-.472-1.5-.798.18-.152.298-.271.294-.31-.018-.158-2.312-1.166-2.441-1.071",
    style: {
      opacity: 1,
      fill: "#60ac54",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.64642262,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1091.614-271.382a8 8 0 0 0-.037.571.3.3 0 0 0 .306-.032.306.306 0 0 0 .066-.428.31.31 0 0 0-.335-.111",
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1042.206,
    cy: 429.927,
    r: 0.306,
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    transform: "rotate(-36.288)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1044.041,
    cy: 428.008,
    r: 0.306,
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    transform: "rotate(-36.288)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1045.844,
    cy: 429.96,
    r: 0.306,
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    transform: "rotate(-36.288)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1047.217,
    cy: 427.033,
    r: 0.306,
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    transform: "rotate(-36.288)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1048.622,
    cy: 428.968,
    r: 0.306,
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    transform: "rotate(-36.288)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1050.722,
    cy: 426.983,
    r: 0.306,
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    transform: "rotate(-36.288)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1051.566,
    cy: 430.059,
    r: 0.306,
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    transform: "rotate(-36.288)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1052.376,
    cy: 428.472,
    r: 0.306,
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    transform: "rotate(-36.288)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1042.801,
    cy: 426.19,
    r: 0.306,
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    transform: "rotate(-36.288)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1039.907,
    cy: 430.092,
    r: 0.306,
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    transform: "rotate(-36.288)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1107.096-268.498a.306.306 0 0 0-.066.428.31.31 0 0 0 .3.12 8 8 0 0 0 .16-.52.306.306 0 0 0-.394-.028z",
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -1048.36,
    cy: 438.719,
    r: 0.306,
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    transform: "scale(-1 1)rotate(36.288)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -1046.229,
    cy: 440.133,
    r: 0.306,
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    transform: "scale(-1 1)rotate(36.288)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -1045.067,
    cy: 437.253,
    r: 0.306,
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    transform: "scale(-1 1)rotate(36.288)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -1043.661,
    cy: 439.187,
    r: 0.306,
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    transform: "scale(-1 1)rotate(36.288)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -1041.561,
    cy: 437.203,
    r: 0.306,
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    transform: "scale(-1 1)rotate(36.288)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -1049.482,
    cy: 436.409,
    r: 0.306,
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    transform: "scale(-1 1)rotate(36.288)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -1052.376,
    cy: 436.687,
    r: 0.306,
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    transform: "scale(-1 1)rotate(36.288)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1099.406-262.623a.3.3 0 0 0-.084.092 8 8 0 0 0 .53.006l-.022-.03a.306.306 0 0 0-.428-.065zM1100.719-278.663l.012.018a.306.306 0 0 0 .428.066l.013-.01a8 8 0 0 0-.452-.074zM1104.055-277.379a.306.306 0 0 0-.066.428.306.306 0 0 0 .428.065.3.3 0 0 0 .124-.221 8 8 0 0 0-.434-.303.3.3 0 0 0-.052.032zM1096.13-263.465a.3.3 0 0 0-.078.082 8 8 0 0 0 .55.254.3.3 0 0 0-.045-.27.306.306 0 0 0-.428-.066",
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1104.55-277.1c.053.771.207 1.892.305 1.935.036.016.183-.062.382-.187.087.81.22 1.63.313 1.67.039.016.186-.057.389-.18.105.898.248 1.74.351 1.786.086.038.608-.284 1.206-.701a8.1 8.1 0 0 0-1.058-2.335 8.1 8.1 0 0 0-1.888-1.988",
    style: {
      opacity: 1,
      fill: "#60ac54",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.64642262,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1099.92-278.731a8 8 0 0 0-.69.014 8 8 0 0 1 .69-.014m.562.045a8 8 0 0 1 .442.055 8 8 0 0 0-.442-.055m-1.662.007a8 8 0 0 0-.397.048 8 8 0 0 1 .397-.048m2.433.107a8 8 0 0 1 .491.112 8 8 0 0 0-.49-.112m-3.233.02a8 8 0 0 0-.388.086 8 8 0 0 1 .388-.087m3.986.168a8 8 0 0 1 .532.178 8 8 0 0 0-.532-.178m-4.769.036a8 8 0 0 0-.38.127 8 8 0 0 1 .38-.127m5.508.224a8 8 0 0 1 .556.252 8 8 0 0 0-.556-.252m-6.266.06a8 8 0 0 0-.364.162 8 8 0 0 1 .364-.163m6.974.27a8 8 0 0 1 .572.33 8 8 0 0 0-.572-.33m-7.705.088a8 8 0 0 0-.343.197 8 8 0 0 1 .343-.197m8.381.312a8 8 0 0 1 .573.412 8 8 0 0 0-.573-.412m-9.063.112a8 8 0 0 0-.329.235 8 8 0 0 1 .33-.235m9.698.35a8 8 0 0 1 .562.497 8 8 0 0 0-.562-.497m-10.337.143a8 8 0 0 0-.306.268 8 8 0 0 1 .306-.268m10.925.38a8 8 0 0 1 .537.58 8 8 0 0 0-.537-.58m.537.58a19.8 19.8 0 0 1-3.7 7.537 20.2 20.2 0 0 1-5.93 5.017 8.1 8.1 0 0 0 3.185.758 8.11 8.11 0 0 0 8.345-7.87 8.1 8.1 0 0 0-1.9-5.442m-12.056-.4a8 8 0 0 0-.27.29 8 8 0 0 1 .27-.29m-.533.614a8 8 0 0 0-.238.315 8 8 0 0 1 .238-.315m-.463.658a8 8 0 0 0-.21.344 8 8 0 0 1 .21-.344m-.398.704a8 8 0 0 0-.175.362 8 8 0 0 1 .176-.362m-.326.741a8 8 0 0 0-.138.378 8 8 0 0 1 .138-.378m-.251.773a8 8 0 0 0-.099.387 8 8 0 0 1 .099-.387m-.172.79a8 8 0 0 0-.06.396 8 8 0 0 1 .06-.396m-.115 1.087a8 8 0 0 0 .01.694 8 8 0 0 1-.01-.694m.05 1.088a8 8 0 0 0 .05.416 8 8 0 0 1-.05-.416m.123.785a8 8 0 0 0 .096.43 8 8 0 0 1-.096-.43m.2.774a8 8 0 0 0 .142.43 8 8 0 0 1-.143-.43m.276.755a8 8 0 0 0 .189.422 8 8 0 0 1-.189-.422m.35.723a8 8 0 0 0 .235.408 8 8 0 0 1-.235-.408m.421.686a8 8 0 0 0 .28.39 8 8 0 0 1-.28-.39m.486.634a8 8 0 0 0 .326.37 8 8 0 0 1-.326-.37m.549.59a8 8 0 0 0 .367.342 8 8 0 0 1-.367-.342m.6.53a8 8 0 0 0 .408.31 8 8 0 0 1-.409-.31m.653.47a8 8 0 0 0 .443.272 8 8 0 0 1-.443-.272",
    style: {
      opacity: 1,
      fill: "#000",
      fillOpacity: 0.1220657,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.7843138,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(24.028 -688.52 -1552.272)scale(.64532)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1350.276,
    cy: -215.386,
    r: 12.568,
    style: {
      opacity: 1,
      fill: "#da1300",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 2.76499987,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M961.268 449.264a48 48 0 0 0-2.04 2.656c1.897 1.24 3.873 2.986 5.88 4.853 3.519 3.275 7.117 6.876 11.677 7.36s8.738-2.316 12.69-4.826c3.951-2.511 7.712-4.734 10.498-4.541s5.97 2.875 9.322 5.84 6.927 6.248 11.457 6.119 8.569-3.532 12.424-6.778c1.779-1.498 3.529-2.952 5.142-4.164a48 48 0 0 0-1.834-2.86c-1.802 1.367-3.585 2.984-5.412 4.522-3.79 3.192-7.646 5.931-10.408 6.01-2.762.08-5.874-2.359-9.2-5.3-3.325-2.942-6.807-6.343-11.27-6.651-4.465-.308-8.535 2.55-12.47 5.049-3.933 2.5-7.692 4.64-10.591 4.332-2.9-.308-6.28-3.225-9.803-6.502-1.929-1.795-3.909-3.678-6.062-5.12M1023.002 497.412c-4.53-.13-8.106 3.155-11.457 6.12-3.351 2.964-6.537 5.647-9.322 5.84-2.786.191-6.547-2.031-10.498-4.542-3.952-2.51-8.13-5.312-12.69-4.828s-8.158 4.087-11.678 7.361c-1.739 1.619-3.457 3.156-5.119 4.346a48 48 0 0 0 2.332 2.418c1.751-1.317 3.4-2.875 5.01-4.373 3.522-3.278 6.904-6.196 9.803-6.504s6.658 1.834 10.592 4.334 8.004 5.357 12.468 5.049 7.946-3.709 11.272-6.65 6.437-5.38 9.2-5.301 6.616 2.818 10.407 6.01c.704.592 1.397 1.194 2.092 1.792a48 48 0 0 0 1.912-2.713c-.63-.523-1.26-1.044-1.9-1.584-3.855-3.245-7.894-6.645-12.424-6.775",
    style: {
      color: "#000",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: "normal",
      fontFamily: "sans-serif",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontFeatureSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      writingMode: "lr-tb",
      direction: "ltr",
      textOrientation: "mixed",
      dominantBaseline: "auto",
      baselineShift: "baseline",
      textAnchor: "start",
      whiteSpace: "normal",
      shapePadding: 0,
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      vectorEffect: "none",
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.2692914,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto"
    },
    transform: "matrix(.26458 0 0 .26458 1086.355 -342.377)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1343.82-226.168c.01 0 .03 0 .52-.184.49-.183 1.441-.549 2.158-.502s1.196.507 1.775.501c.58-.006 1.258-.478 1.871-.456.614.021 1.163.536 1.772.522.608-.014 1.274-.555 2.057-.623s1.68.337 2.19.54c.51.202.67.202.316-.024-.356-.225-1.668-.973-2.316-1.69-.65-.717-.56-1.215-.835-1.719-.276-.503-1.144-1.282-1.949-1.618-.804-.336-1.664-.336-2.47-.083-.804.254-1.554.761-1.956 1.395s-.456 1.394-.923 2.073c-.466.68-1.344 1.275-1.781 1.571-.438.297-.438.297-.428.297",
    style: {
      fill: "#ffe600",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: ".26458332px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M962.023 459.723c-.402-.03-.81.007-1.203.111a3.63 3.63 0 0 0-1.968 1.336l.796.598a2.68 2.68 0 0 1 1.432-.975c.562-.15 1.187-.1 1.72.133.711.309 1.282.97 1.522 1.72a3.2 3.2 0 0 1-.193 2.34c-.355.724-.99 1.323-1.734 1.668a4.26 4.26 0 0 1-2.444.319 4.66 4.66 0 0 1-3.043-1.912l-.13.091a7.6 7.6 0 0 0-.844-1.398 7.6 7.6 0 0 0-2.297-1.975 48 48 0 0 0-.35.957 6.6 6.6 0 0 1 1.86 1.631c.701.906 1.163 2.001 1.33 3.137a6.9 6.9 0 0 1-.364 3.396 7.1 7.1 0 0 1-1.941 2.819 6.5 6.5 0 0 1-2.666 1.44 5.7 5.7 0 0 1-1.274.165 48 48 0 0 0-.048 1 6.7 6.7 0 0 0 1.564-.199c1.148-.294 2.2-.884 3.078-1.66a8.1 8.1 0 0 0 2.223-3.219 7.9 7.9 0 0 0 .414-3.89c-.021-.142-.061-.28-.09-.42a5.6 5.6 0 0 0 2.422 1.025 5.24 5.24 0 0 0 3.02-.398 4.63 4.63 0 0 0 2.207-2.133c.467-.95.576-2.066.25-3.086v-.008a3.79 3.79 0 0 0-2.075-2.324 3.6 3.6 0 0 0-1.173-.29zm78.833.986a6 6 0 0 0-.71.31 6.6 6.6 0 0 0-2.945 3.05 6.64 6.64 0 0 0-.473 4.214 6.63 6.63 0 0 0 2.2 3.625 6.62 6.62 0 0 0 4.015 1.528 6.6 6.6 0 0 0 1.532-.157 48 48 0 0 0-.121-.994c-.456.102-.92.169-1.383.154a5.63 5.63 0 0 1-3.403-1.298 5.64 5.64 0 0 1-1.859-3.07 5.65 5.65 0 0 1 .398-3.575 5.63 5.63 0 0 1 2.495-2.582c.214-.11.44-.194.668-.275a48 48 0 0 0-.416-.93zm-37.147.3a5.3 5.3 0 0 0-1.814.22c-1.168.355-2.184 1.103-2.915 2.06a6.6 6.6 0 0 0-1.322 3.588 7.1 7.1 0 0 0 .813 3.713 7.7 7.7 0 0 0 2.554 2.805 8.4 8.4 0 0 0 3.536 1.322c2.722.368 5.37-.54 7.787-1.551 2.41-1.009 4.75-2.148 7.213-2.451 2.365-.29 4.81.198 7.043 1.144 1.805.766 3.48 1.829 5.078 3.016a10.8 10.8 0 0 0-5.979.373c-2.588.937-4.794 2.925-5.869 5.477-1.076 2.556-.942 5.605.486 8.002 1.027 1.724 2.699 3.061 4.65 3.595 1.957.535 4.14.22 5.82-.945a6.14 6.14 0 0 0 1.903-2.104c.46-.847.71-1.816.672-2.79a4.9 4.9 0 0 0-.953-2.731 4.44 4.44 0 0 0-2.406-1.647 4.25 4.25 0 0 0-2.783.221 4.26 4.26 0 0 0-2.037 1.912l.884.457a3.27 3.27 0 0 1 1.551-1.453 3.3 3.3 0 0 1 2.127-.17v.008c.732.193 1.4.655 1.86 1.27.459.615.72 1.387.753 2.17.038.78-.167 1.577-.546 2.273a5.2 5.2 0 0 1-1.602 1.766c-1.413.98-3.303 1.26-4.977.803-1.678-.46-3.16-1.642-4.058-3.15-1.25-2.098-1.376-4.838-.422-7.102.956-2.27 2.954-4.08 5.285-4.924a9.8 9.8 0 0 1 6.371-.082c.68.227 1.332.54 1.945.914 1 .86 1.966 1.762 2.897 2.697.066.094.138.183.201.28l.045-.03a52.6 52.6 0 0 1 6.707 8.424 48 48 0 0 0 .223-1.477 53.5 53.5 0 0 0-6.395-7.834 10.75 10.75 0 0 0-3.072-2.865 52 52 0 0 0-1.523-1.262c-1.972-1.564-4.09-3.016-6.446-4.015-2.358-1-4.97-1.535-7.552-1.217-2.685.33-5.104 1.53-7.477 2.523-2.368.992-4.854 1.804-7.271 1.477a7.4 7.4 0 0 1-3.116-1.158 6.7 6.7 0 0 1-2.222-2.436 6.1 6.1 0 0 1-.702-3.19 5.6 5.6 0 0 1 1.116-3.04c.61-.8 1.467-1.417 2.414-1.705.944-.288 2-.24 2.879.17.875.408 1.59 1.194 1.867 2.103.14.454.177.946.101 1.416a3 3 0 0 1-.552 1.285c-.314.412-.75.737-1.233.922a2.84 2.84 0 0 1-1.527.14l-.186.983a3.83 3.83 0 0 0 3.743-1.44 3.9 3.9 0 0 0 .738-1.728v-.006c.098-.62.06-1.257-.125-1.861-.367-1.206-1.27-2.197-2.399-2.723a4.9 4.9 0 0 0-1.78-.441zm-32.293 6.016c-1.262.006-2.52.409-3.521 1.198a5.506 5.506 0 0 0-2.045 4.924c.11.922.451 1.813.996 2.568a5.46 5.46 0 0 0 2.119 1.75l.42-.9a4.49 4.49 0 0 1-2.54-3.538 4.7 4.7 0 0 1 .311-2.22 4.5 4.5 0 0 1 1.358-1.795c1.081-.851 2.586-1.172 3.949-.885 1.368.288 2.62 1.164 3.418 2.332.801 1.171 1.171 2.64 1.094 4.074-.076 1.436-.587 2.855-1.403 4.06-.858 1.27-2.047 2.312-3.38 3.116a13.25 13.25 0 0 1-8.475 1.771l-.004.028c-.63-.054-1.262-.08-1.893-.053-3.207.138-6.318 1.296-8.926 3.139a18.6 18.6 0 0 0-2.13 1.77 48 48 0 0 0 .257 1.148c.751-.773 1.57-1.479 2.45-2.1 2.461-1.74 5.4-2.83 8.394-2.959 2.99-.129 6.044.73 8.43 2.51 1.562 1.165 2.848 2.714 4.185 4.252 1.34 1.538 2.776 3.105 4.614 4.178 1.696.99 3.649 1.488 5.603 1.505a12.8 12.8 0 0 0 5.647-1.29c3.5-1.691 6.132-4.85 7.582-8.417.09-.22.16-.45.242-.675l.228.033c.392-2.619 1.93-5.065 4.12-6.555 1.76-1.198 3.985-1.778 6.023-1.336a6.1 6.1 0 0 1 2.754 1.381 5.28 5.28 0 0 1 1.594 2.582c.253.99.182 2.071-.215 3.006a4.4 4.4 0 0 1-2.022 2.191 4.13 4.13 0 0 1-2.94.303c-.959-.27-1.82-.935-2.302-1.8-.57-1.029-.599-2.374-.072-3.426l-.892-.442a4.71 4.71 0 0 0 .094 4.348 4.83 4.83 0 0 0 2.9 2.281 5.1 5.1 0 0 0 3.662-.377 5.4 5.4 0 0 0 2.496-2.687 5.74 5.74 0 0 0 .256-3.647 6.25 6.25 0 0 0-1.896-3.078 7.05 7.05 0 0 0-3.202-1.617c-2.357-.511-4.838.16-6.796 1.492a10.7 10.7 0 0 0-2.895 2.965c.008-.194.032-.387.031-.582 0-1.954-.499-3.934-1.558-5.602a8.66 8.66 0 0 0-2.975-2.873 7.75 7.75 0 0 0-4.023-1.039c-1.412.034-2.818.483-3.965 1.32a6.44 6.44 0 0 0-2.407 3.434 6.2 6.2 0 0 0 .147 3.764 6.17 6.17 0 0 0 2.31 2.968 6.168 6.168 0 0 0 7.168-.186l-.603-.796a5.2 5.2 0 0 1-2.977 1.041 5.2 5.2 0 0 1-3.025-.887 5.2 5.2 0 0 1-1.934-2.488 5.2 5.2 0 0 1-.117-3.145 5.46 5.46 0 0 1 2.03-2.892 6.05 6.05 0 0 1 3.396-1.137c1.213-.03 2.437.305 3.498.914a7.7 7.7 0 0 1 2.635 2.541c.944 1.486 1.402 3.28 1.402 5.063 0 1.788-.408 3.58-1.092 5.263-1.367 3.365-3.857 6.328-7.093 7.891-1.62.782-3.417 1.212-5.206 1.197-1.786-.015-3.572-.477-5.107-1.373-1.667-.973-3.039-2.45-4.363-3.972-1.326-1.524-2.65-3.137-4.34-4.399a13.3 13.3 0 0 0-3.229-1.762c1.777-.285 3.501-.893 5.045-1.824 1.438-.866 2.735-2.012 3.69-3.424.909-1.344 1.493-2.924 1.58-4.562.09-1.641-.333-3.317-1.27-4.688-.938-1.373-2.392-2.4-4.037-2.746h-.002a6 6 0 0 0-1.254-.127zm-17.77 28.418c-.322.012-.643.05-.96.104a48 48 0 0 0 .324.974c.224-.031.448-.066.674-.074a6.56 6.56 0 0 1 3.587.932 6.57 6.57 0 0 1 2.502 2.738 6.6 6.6 0 0 1 .606 3.662c-.167 1.307-.768 2.548-1.649 3.53a48 48 0 0 0 .608.85 7.58 7.58 0 0 0 2.033-4.255 7.6 7.6 0 0 0-.695-4.222 7.55 7.55 0 0 0-2.885-3.16 7.56 7.56 0 0 0-4.143-1.079z",
    style: {
      color: "#000",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: "normal",
      fontFamily: "sans-serif",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontFeatureSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      writingMode: "lr-tb",
      direction: "ltr",
      textOrientation: "mixed",
      dominantBaseline: "auto",
      baselineShift: "baseline",
      textAnchor: "start",
      whiteSpace: "normal",
      shapePadding: 0,
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      vectorEffect: "none",
      fill: "#60ac54",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: ".99999994px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto"
    },
    transform: "matrix(.26458 0 0 .26458 1086.355 -342.377)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M997.5 432.467a48 48 0 0 0-4.033.201 48 48 0 0 1 4.033-.201m3.3.166a48 48 0 0 1 2.597.246 48 48 0 0 0-2.596-.246m-9.728.326a48 48 0 0 0-2.32.352 48 48 0 0 1 2.32-.352m14.262.213a48 48 0 0 1 2.895.572 48 48 0 0 0-2.895-.572m-18.926.664a48 48 0 0 0-2.256.576 48 48 0 0 1 2.256-.576m23.367.303a48 48 0 0 1 3.145.953 48 48 0 0 0-3.145-.953m-27.912 1.033a48 48 0 0 0-2.209.807 48 48 0 0 1 2.21-.807m32.28.367a48 48 0 0 1 3.298 1.375 48 48 0 0 0-3.298-1.375m-36.672 1.418a48 48 0 0 0-2.102 1.014 48 48 0 0 1 2.102-1.014m40.877.395a48 48 0 0 1 3.4 1.834 48 48 0 0 0-3.4-1.834m-45.092 1.832a48 48 0 0 0-1.975 1.21 48 48 0 0 1 1.975-1.21m49.117.386a48 48 0 0 1 3.426 2.317 48 48 0 0 0-3.426-2.317m-53.037 2.215a48 48 0 0 0-1.887 1.434 48 48 0 0 1 1.887-1.434m56.832.383a48 48 0 0 1 3.375 2.812 48 48 0 0 0-3.375-2.812m-60.492 2.61a48 48 0 0 0-1.742 1.622 48 48 0 0 1 1.742-1.623m64.025.349a48 48 0 0 1 3.242 3.305 48 48 0 0 0-3.242-3.305m3.242 3.305c-3.489 16.143-10.469 31.532-20.367 44.757-9.147 12.223-20.763 22.533-33.857 30.391a47.5 47.5 0 0 0 18.781 3.887 47.5 47.5 0 0 0 47.5-47.5 47.5 47.5 0 0 0-12.057-31.535m-70.644-.278a48 48 0 0 0-1.535 1.748 48 48 0 0 1 1.535-1.748m-3.014 3.692a48 48 0 0 0-1.344 1.88 48 48 0 0 1 1.344-1.88m-2.6 3.927a48 48 0 0 0-1.173 2.05 48 48 0 0 1 1.174-2.05m-2.206 4.19a48 48 0 0 0-.963 2.15 48 48 0 0 1 .963-2.15m-1.784 4.396a48 48 0 0 0-.744 2.237 48 48 0 0 1 .744-2.237m-1.338 4.567a48 48 0 0 0-.511 2.281 48 48 0 0 1 .511-2.281m-.87 4.658a48 48 0 0 0-.284 2.326 48 48 0 0 1 .283-2.326m-.487 6.383a48 48 0 0 0 .203 4.06 48 48 0 0 1-.203-4.06m.482 6.357a48 48 0 0 0 .368 2.426 48 48 0 0 1-.368-2.426m.852 4.578a48 48 0 0 0 .64 2.504 48 48 0 0 1-.64-2.504m1.3 4.494a48 48 0 0 0 .913 2.497 48 48 0 0 1-.912-2.497m1.755 4.375a48 48 0 0 0 1.175 2.434 48 48 0 0 1-1.175-2.434m2.172 4.172a48 48 0 0 0 1.44 2.348 48 48 0 0 1-1.44-2.348m2.582 3.944a48 48 0 0 0 1.7 2.234 48 48 0 0 1-1.7-2.234m2.937 3.642a48 48 0 0 0 1.967 2.112 48 48 0 0 1-1.967-2.112m3.309 3.36a48 48 0 0 0 2.209 1.937 48 48 0 0 1-2.21-1.937m3.601 2.998a48 48 0 0 0 2.444 1.746 48 48 0 0 1-2.444-1.746m3.908 2.644a48 48 0 0 0 2.641 1.514 48 48 0 0 1-2.64-1.514",
    style: {
      opacity: 1,
      fill: "#000",
      fillOpacity: 0.1220657,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 10.45039272,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    transform: "matrix(.26458 0 0 .26458 1086.355 -342.377)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1056.122-864.086c0 2.066-.838 3.741-1.87 3.741-.555 0-1.052-.48-1.395-1.246-.296-.662-.1-1.588-.1-2.547 0-.887.018-1.598.036-2.291.023-.92.869-1.4 1.459-1.4 1.033 0 1.87 1.676 1.87 3.743z",
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 0.36150237,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.86500001,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    transform: "rotate(30)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1342.54-213.038c-.696-.172-.866-1.524-.444-2.103.473-.65 2.018-.958 2.397-.25.48.899-.964 2.598-1.953 2.353",
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 0.36150237,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.86500001,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.527 283.71v113.495h175.276V283.71z",
    style: {
      fill: "#fff",
      fillOpacity: 0.41784036,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.87204337,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "normal"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinterBreak);
export default __webpack_public_path__ + "static/media/winter-break.dcc91d1d19a46099ce7cd457c9493ce4.svg";
export { ForwardRef as ReactComponent };